import { typography } from "../typography/typography.js";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
const MuiDatePickerToolbar = {
  styleOverrides: {
    title: ({ theme }) => ({
      ...typography["Lato H4"],
      color: theme.palette.grey[800]
    })
  }
};
export {
  MuiDatePickerToolbar
};
